import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OpportunityService {
  private data = [
    {step:1, 
      actions:[
        {
          item:1, 
          texto:"Confirmar que el cliente y la oportunidad estén correctamente registrados en el CRM (datos de contacto, empresa, requerimiento)."
        },
        {
          item:2, 
          texto:"Validar que el requerimiento corresponde a la oferta de la empresa (alcance y factibilidad)."
        },
        {
          item:3, 
          texto:"Asignar responsable interno (ejecutivo comercial / preventa)."
        }
    ]
    }
  ]

  getOpportunitiesStep(){
    return this.data;
  }
}
